import { createSelector } from "reselect";
import { AppState } from "app/shared/store/root.reducer";

const getStatementStore = (state: AppState) => state.termDepositStatement;
const getListStatement = (state: AppState) => state.termDepositStatement.responseList;
const getDataCreate = (state: AppState) => state.termDepositStatement.dataCreate;
const getResponseCreated = (state: AppState) => state.termDepositStatement.responseCreate;
const getResponseConfirm = (state: AppState) => state.termDepositStatement.responseConfirm;
const getResponseAuth = (state: AppState) => state.termDepositStatement.responseAuth;

const getPending = (state: AppState) => state.termDepositStatement.pending;

export const getTermDepositStatementSelector = createSelector(getStatementStore, (data) => data);
export const getTermDepositListStatementSelector = createSelector(getListStatement, (info) => info);

export const getTermDepositStatementDataCreateSelector = createSelector(getDataCreate, (data) => data);

export const getTermDepositStatementResponseCreatedSelector = createSelector(getResponseCreated, (res) => res);

export const getTermDepositStatementResponseConfirmSelector = createSelector(getResponseConfirm, (res) => res);

export const getTermDepositStatementResponseAuthSelector = createSelector(getResponseAuth, (res) => res);

export const getTermDepositStatementPendingSelector = createSelector(getPending, (status) => status);
